import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { IdentityService } from './identity.service';

export const authGuard: CanActivateFn = () => {
    const identityService = inject(IdentityService);
    const router = inject(Router);

    return identityService.stateChanges.pipe(
        take(1),
        map(state => {
            if (state.user) {
                return true;
            }
            return router.createUrlTree(['/login']);
        }),
    );
};
